import { motion, useAnimationControls } from "framer-motion";
import * as React from "react";
import { cn } from "@/lib/utils";

type MarqueeProps = {
  text?: string;
  speed?: number; // pixels per second
  className?: string;
  stripColor?: string;
  textColor?: string;
};

export function Marquee({
  text = "A TO A — AGENT TO AGENT",
  speed = 120,
  className,
  stripColor = "#00BBF9",
  textColor = "#000000",
}: MarqueeProps) {
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  const contentRef = React.useRef<HTMLDivElement | null>(null);
  const controls = useAnimationControls();

  React.useEffect(() => {
    const contentWidth = contentRef.current?.scrollWidth ?? 1000;
    const distance = contentWidth / 2; // duplicate content -> half loop
    const duration = distance / speed;
    controls.start({
      x: [0, -distance],
      transition: { repeat: Infinity, ease: "linear", duration },
    });
  }, [controls, speed]);

  const item = (
    <div className="flex items-center gap-6 px-6 uppercase">
      {Array.from({ length: 12 }).map((_, i) => (
        <span key={i} className="whitespace-nowrap text-lg font-extrabold tracking-widest">
          {text}
        </span>
      ))}
    </div>
  );

  return (
    <div
      className={cn(
        "relative select-none overflow-hidden border-y-4 border-black",
        "w-screen max-w-[100vw] ml-[calc(50%-50vw)] mr-[calc(50%-50vw)]",
        className,
      )}
      style={{ backgroundColor: stripColor, color: textColor }}
    >
      <div ref={containerRef} className="relative w-full">
        <motion.div ref={contentRef} className="inline-flex will-change-transform" animate={controls}>
          <div aria-hidden>{item}</div>
          <div aria-hidden>{item}</div>
        </motion.div>
      </div>
    </div>
  );
}

export default Marquee;


